import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from '../../../../store';

export const useSessionInfoStoreData = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.auth);
  const { list: providerAssignments = [] } = useSelector(
    (state: RootState) => state.providerAssignment,
  );
  const { list: clients = [] } = useSelector((state: RootState) => state.clients);
  const {
    current: session,
    narrativeSuggestionLoading,
    loading: sessionLoading,
  } = useSelector((state: RootState) => state.sessions);
  const { clientCohortAssignments, loading: cohortAssignmentLoading } = useSelector(
    (state: RootState) => state.cohorts,
  );

  return {
    clientCohortAssignments,
    clients,
    cohortAssignmentLoading,
    dispatch,
    narrativeSuggestionLoading,
    providerAssignments,
    session,
    sessionLoading,
    user,
  };
};
